import React, { useEffect, useMemo, useState } from 'react'
import { useGeneralParams } from '../../../../hooks/useDataPaginate'
import { MinimalActionButton } from '../../../../components/form/minimalActionButton'
import { setReloadMainTable } from '../../../../store/slices/auth/authSlice'
import { TabBoard } from '../../../../components/tab/TabBoard'
import Bars from './VentaPorVendedorProductoBarsCharts'
import { DefaultParamsForRecall } from '../../../../utils/defaulStates'
import { DefaultMultiSelectVendedores } from '../../../../components/defaults'

export const VentasPorVendedorProductos = ({ urlApi, title, subtitle }) => {
  const [productos, setProductos] = useState([])

  const [productoNombre, setProductoNombre] = useState('AC - 200LT')

  const {
    dispatch,
    data, setData,
    paginate, setPaginate,
    selectedDay, setSelectedDay,
    selecteds, setSelecteds,
    selectAllChecked, setSelectAllChecked,
    isChecked, setIsChecked,
    stateData, setStateData,

    requestAuthPaginate,
    TableContainer,
    Paginator,
    formatFilters,
    RangeDate,
    TableSection,
    ActionSection,
    Section,

  } = useGeneralParams({ aditionals: { rolnames: ['carro-distribuidor', 'punto-de-venta'] } })

  const productoLabel = useMemo(() => {
    if ((productoNombre || '').toLowerCase() === 'all') return 'Todos los productos'
    return productoNombre
  }, [productoNombre])

  const finalUrl = useMemo(() => {
    const safe = encodeURIComponent(productoNombre || 'all')
    if (!urlApi) return ''

    if (urlApi.includes(':producto_nombre')) {
      return urlApi.replace(':producto_nombre', safe)
    }

    if (/\/informe\/vendedores\/[^/]+\/pag$/.test(urlApi)) {
      return urlApi.replace(/\/informe\/vendedores\/[^/]+\/pag$/, `/informe/vendedores/${safe}/pag`)
    }

    if (urlApi.endsWith('/pag')) return urlApi.replace('/pag', `/${safe}/pag`)
    return `${urlApi}/${safe}/pag`
  }, [urlApi, productoNombre])

  const getProductosForSelect = async () => {
    await requestAuthPaginate({
      method: 'get',
      url: '/productos/pag',
      data: null,
      queries: { currentPage: 1, pageSize: 1000, filterBy: 'nombre', filterParam: '' },
      setData: (payload) => {
        const list = Array.isArray(payload?.data) ? payload.data : []
        setProductos(list)
      },
      setStateData: () => {},
      setQueries: () => {},
      dispatch: dispatch,
      aditionalParams: {}
    })
  }

  const getDataPaginate = async () => {
    if (!finalUrl) return

    await requestAuthPaginate({
      method: 'get',
      url: finalUrl,
      data: null,
      queries: paginate,
      setData: setData,
      setStateData: setStateData,
      setQueries: setPaginate,
      dispatch: dispatch,
      aditionalParams: { filterBy: 'nombre' }
    })
  }

  useEffect(() => {
    getProductosForSelect()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    getDataPaginate()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...DefaultParamsForRecall(paginate), paginate.rolnames, paginate.tipoMovimiento, productoNombre])

  useEffect(() => {
    setSelectAllChecked(false)
    setIsChecked(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...DefaultParamsForRecall(paginate), productoNombre])

  const recall = () => {
    getDataPaginate()
    setSelecteds([])
    setSelectAllChecked(false)
    setIsChecked(false)
    dispatch(setReloadMainTable())
  }

  return (
    <TabBoard
      title={title}
      subtitle={`Ventas en Unidades de ${productoLabel}`}
    >
      <Section>
        <ActionSection>
          <div className='flex gap-2 flex-wrap'>
            <RangeDate
              selectedDay={selectedDay}
              setSelectedDay={setSelectedDay}
              paginate={paginate}
              setPaginate={setPaginate}
            />

            <DefaultMultiSelectVendedores
              paginate={paginate}
              setPaginate={setPaginate}
              formatFilter={formatFilters}
            />

            <select
              className='border rounded px-2 py-2 text-sm'
              value={productoNombre}
              onChange={(e) => {
                setProductoNombre(e.target.value)
                setPaginate(prev => ({ ...prev, currentPage: 1 }))
              }}
            >
              <option value="all">Todos los productos</option>
              {(productos || []).map((p) => (
                <option key={p.id} value={p.nombre}>
                  {p.nombre}
                </option>
              ))}
            </select>

            <MinimalActionButton icon='repeat' label='' action={recall} />
          </div>
        </ActionSection>

        <TableSection stateData={stateData} paginator={Paginator} data={data}>
          <TableContainer
            headers={[
              { label: 'Responsable', columns: ['nombres:apellido_paterno:apellido_materno', 'roles'] },
            ]}
            data={data.data}
            aditionalCols={data.aditionalCols}
            aditionalColsRef='cantidades'
            checkList={false}
            selecteds={selecteds}
            setSelecteds={setSelecteds}
            selectAllChecked={selectAllChecked}
            setSelectAllChecked={setSelectAllChecked}
            isChecked={isChecked}
            setIsChecked={setIsChecked}
            stateData={stateData}
          />
        </TableSection>
      </Section>

      <Bars
        data={data.data}
        aditionalCols={data.aditionalCols ?? []}
        hoverTitle='Ventas'
      />
    </TabBoard>
  )
}